import { writable } from "svelte/store"

// A writable mirrored to localStorage, so the value survives a reload and new
// tabs start with it. All tabs share the key: a tab that is not the active one
// pauses the storage and keeps its changes in memory (see sessionCookie.js).
export function createPersistedStore(key) {
  let current = JSON.parse(localStorage.getItem(key))
  let paused = false
  const { subscribe, set } = writable(current)

  const save = () =>
    localStorage.setItem(key, current ? JSON.stringify(current) : null)

  return {
    subscribe,
    set: (value) => {
      current = value
      if (!paused) save()
      set(value)
    },
    pauseStorage: () => {
      paused = true
    },
    resumeStorage: () => {
      paused = false
    },
    // Stores this tab's value again, another tab may have overwritten it.
    persist: save,
  }
}
